import { Entity } from '@hglobal/common';

export enum ItSupportRequestStatus {
  ManagerApproval = 'Manager Approval',
  Done = 'Done',
  ChangeInfo = 'Change Info',
  ITManagerApproval = 'IT Manager Approval',
  ToDo = 'To Do',
  New = 'New',
  Canceled = 'Canceled',
  InProgress = 'In Progress',
  OnHold = 'On hold',
}

export interface ItSupportRequest extends Entity {
  createdAt: string;
  issueType: string;
  status: ItSupportRequestStatus;
  jiraTicketId: string;
  description: string;
  summary: string;
}
